export default "__VITE_ASSET__d67f90b1__"